import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { OperationType } from 'common/constants/sm-constants';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { SystemService } from 'common/services/core-services/system.service';

export interface StateChangeData {
    event: any;
    field: any;
  }

@Component({
    selector: 'sm-form',
    templateUrl: './sm-form.component.html',
    styleUrls: ['./sm-form.component.scss']
})
export class SmFormComponent implements OnInit, AfterViewChecked {
    @Input() Form;
    @Input() propData;
    @Input() propMeta;
    @Input() isChildForm: boolean = false;
    @Input() parentForm: any = null;
    @Input() showHeader: any = true;
    @Output() stateChanged = new EventEmitter<StateChangeData>();
    @Output() Submit = new EventEmitter<any>();
    @Output() Reset = new EventEmitter<any>();
    @Output() Validate = new EventEmitter<any>();
    @Output() modify = new EventEmitter<any>();
    @Output() initInput = new EventEmitter<any>();
    @Output() selectFilters = new EventEmitter<any>();
    rowNumbers: any;
    formControls: any[] = [];
    isReset: boolean = false;
    private initialFormValues: any;
    constructor(
        protected systemService: SystemService,
        private readonly changeDetectorRef: ChangeDetectorRef,

        // private modalService: NgbModal

    ) { }

    ngOnInit(): void {
        this.manageControls();
        this.initialFormValues = this.Form.value;
    }

    ngAfterViewChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    manageControls() {
        this.rowNumbers = Array(this.propMeta.properties.formInfo.numberOfRows)
            .fill(this.propMeta.properties.formInfo.numberOfRows)
            .map((x, i) => i);
        Object.keys(this.propMeta.properties).forEach(field => {
            if (this.propMeta.properties[field].isFormInput) {
                this.formControls.push(this.propMeta.properties[field]);
            }
        });
        this.formControls.sort((a, b) => a.priority - b.priority);
    }

    submitForm() {
        // this.modalService.dismissAll();
        this.Submit.emit(this.Form.value);
        //   this.navigateToTable();

    }


    resetForm() {
        this.Form.reset();
        this.Form.markAsUntouched();
        this.Form.markAsPristine();
        this.isReset = true;
    }

    validateByUrl(control, formControlName, keys) {
        const formData = {
            controls: control,
            name: formControlName,
            key: keys
        };
        this.Validate.emit(control);
        this.modifyOtherField(control);
    }

    evaluate(field) {
        if (field.hasOwnProperty('condition')) {
            const condition = field.propcondition;
            if (condition.evalParam.length > 0) {
                return condition.evalParam.includes(this.Form.value[condition.evalKey]);
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    refreshValidation(event, validationParam, field) {
        this.stateChanged.emit({ event, field })
        this.modifyOtherField(field);
        if (validationParam !== null) {
            validationParam.forEach(validParam => {
                const modelkey = validParam.key;
                const modelval = validParam.value;
                const propvary = validParam.prop;
                const decisiveKey = validParam.decisiveKey;
                if (modelval.includes(event[decisiveKey])) {
                    this.propMeta.properties[modelkey][propvary.key] = propvary.value;
                    if (propvary.key === 'readOnly' || propvary.key === 'propreadOnly') {
                        this.propMeta.properties[modelkey]['required'] = propvary.value ? false : true;
                    } else {
                        this.Form.controls[modelkey].setValidators([Validators.required]);
                    }
                    this.Form.controls[modelkey].updateValueAndValidity();
                } else {
                    this.propMeta.properties[modelkey][propvary.key] = !propvary.value;
                    if (propvary.key === 'readOnly' || propvary.key === 'propreadOnly') {
                        this.propMeta.properties[modelkey]['required'] = !propvary.value ? false : true;
                    }
                    this.Form.controls[modelkey].setValidators(null);
                    this.Form.controls[modelkey].updateValueAndValidity();
                }
            });
        }
    }

    modifyOtherField(fieldData) {
        this.modify.emit(fieldData);
    }

    navigateToTable() {
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.VIEW;
        envelope.transferData = new GridParams();
        this.systemService.navigateByUrl(this.propMeta.redirectPath, envelope);
    }

    validateField(control: string = '') {
        this.Form.controls[control].setErrors(null);
        this.Form.controls[control].markAllAsTouched();
        this.propMeta.properties[control].propCustomError = false;
    }

    getColorCode(event, field) {
        this.Form.patchValue({
            [field.field_Name]: event
        });
    }

    initInputAction(event, field) {
        if (event) {
            this.initInput.emit(field);
        }
    }

    initSelect(event, field) {
        const model = {
            filterOptions: event,
            fieldName: field
        };
        this.selectFilters.emit(model);
    }
}

